import React from 'react';
import ProductLandingPage from './ProductLandingPage';

export default function AiContentCalendarPage() {
  return (
    <ProductLandingPage
      title="AI Content Marketer"
      description="Marketing strategy, social setup, and a calendar that keeps publishing without a full marketing team."
      bullets={[
        'Strategy and content calendar built around your offer.',
        'Social setup, branding, and scheduled posts.',
        'Keep shipping when the team is heads-down on product.',
      ]}
      ctaTo="/sign-up"
      ctaLabel="Start on getupgraded.ai"
    />
  );
}
